<template>
    <nav class="w-100 navbar navbar-expand-sm justify-content-end">
        <ul class="navbar-nav">
            <li class="nav-item">
                <router-link class="nav-link" to="/experience" @click="trackHomeCosaFareNy()" >{{TOP_LINK_COSA_FARE}}</router-link>
            </li>
            <li class="nav-item" v-if="TOP_LINK_CAMBIA_ISOLA !== undefined">
                <router-link class="nav-link" to="/experience" @click="trackHomeCambiaIsola()" >{{TOP_LINK_CAMBIA_ISOLA}}</router-link>
            </li>
            <li class="nav-item">
                <a class="nav-link" :href="TOP_LINK_CHI_SIAMO_URL" target="_blank" @click="trackHomeChiSiamo">{{TOP_LINK_CHI_SIAMO}}</a>
            </li>
            <li class="nav-item">
                <router-link class="nav-link badge badge-secondary" to="/experience" >Area agenzie di viaggio</router-link>
            </li>
        </ul>
    </nav>
</template>

<script>
import AnalyticEvents from '../../../common/AnalyticEvents'
import ContentUtils from '../../../utils/ContentUtils'

export default {
  name: 'Navbar',
  mixins: [AnalyticEvents, ContentUtils]
}
</script>



// WEBPACK FOOTER //
// src/front/components/pages/layout/default/Navbar.vue